import React from "react";
import { FaStar, FaThumbsDown, FaThumbsUp } from "react-icons/fa";

const RatingsAndReviews = () => {
  const overallRating = 4.5;
  const totalRatings = 320;
  const ratingPercentage = (overallRating / 5) * 100;
  const ratingDistribution = [
    { stars: 5, count: 220 },
    { stars: 4, count: 60 },
    { stars: 3, count: 25 },
    { stars: 2, count: 10 },
    { stars: 1, count: 5 },
  ];

  const reviews = [
    {
      name: "Amit Sharma",
      text: "Absolutely loved the fabric and design! Worth every penny.",
      helpful: 12,
      notHelpful: 2,
    },
    {
      name: "Priya Patel",
      text: "Great craftsmanship! The colors are vibrant and beautiful.",
      helpful: 8,
      notHelpful: 1,
    },
  ];

  return (
    <div className="bg-white p-6 rounded-xl shadow-sm w-full">
      <h2 className="text-2xl font-bold mb-4 flex">Ratings & Reviews</h2>
      <div className="flex w-full">
      <div className="flex items-center mb-4 pr-4 border-r-1 border-black">
        <div className="relative w-16 h-16 mr-4">
          <svg className="w-full h-full" viewBox="0 0 36 36">
            <path
              className="text-gray-400 stroke-current"
              strokeWidth="3.5"
              d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
              fill="none"
            />
            <path
              className="text-green-400 stroke-current"
              strokeWidth="3.5"
              strokeDasharray={`${ratingPercentage}, 100`}
              d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
              fill="none"
            />
          </svg>
          <div className="absolute inset-0 flex items-center justify-center text-green-500 font-bold text-lg">
            {overallRating}
          </div>
        </div>
        <div className="flex flex-col">
          <div className="flex ml-2 text-yellow-400">
            {[...Array(5)].map((_, index) => (
              <FaStar key={index} className={index < Math.round(overallRating) ? "text-yellow-300" : "text-gray-300"} />
            ))}
          </div>
          <span className="ml-2">({totalRatings} ratings)</span>
        </div>
      </div>
      <div className="w-full">
        {ratingDistribution.map(({ stars, count }) => (
          <div key={stars} className="flex items-center mb-2">
            <span className="w-6 flex items-center">{stars}<FaStar className= "text-green-300" /></span>
            <div className="bg-gray-200 w-full h-2 rounded-md overflow-hidden mx-2">
              <div
                className="bg-green-400 h-2"
                style={{ width: `${(count / totalRatings) * 100}%` }}
              ></div>
            </div>
            <span>{count}</span>
          </div>
        ))}
      </div>
      </div>
      <h3 className="text-xl font-semibold mt-6 mb-4">Customer Reviews</h3>
      {reviews.map((review, index) => (
        <div key={index} className="bg-white p-4 rounded-lg shadow-md text-black mb-4">
          <div className="flex items-center mb-2">
            <div className="w-10 h-10 bg-gradient-to-r from-green-500 to-pink-500 rounded-full flex items-center justify-center text-white font-bold text-lg">
              {review.name[0]}
            </div>
            <span className="ml-3 font-bold">{review.name}</span>
          </div>
          <p className="mb-2">{review.text}</p>
          <div className="flex items-center space-x-4">
            <button className="flex items-center text-gray-600 hover:text-green-500">
              <FaThumbsUp className="mr-1" /> {review.helpful}
            </button>
            <button className="flex items-center text-gray-600 hover:text-red-500">
              <FaThumbsDown className="mr-1" /> {review.notHelpful}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RatingsAndReviews;
